import axios from '../http'

function add(data) {
    return axios.post('/basedata/raceDoc/add', data);
}

function del(data) {
    return axios.post('/basedata/raceDoc/del', data);
}

function update(data) {
    return axios.post('/basedata/raceDoc/update', data);
}

function query(data) {
    return axios.post('/basedata/raceDoc/query', data);
}


function get(id) {
    return axios.get('/basedata/raceDoc/get?id=' + id);
}

function select() {
    return axios.get('/basedata/raceDoc/select');
}

function importExcel(file){
    let formData = new FormData();
    formData.append("file", file);
    return axios.post("/basedata/raceDoc/importExcel", formData, {headers: {"Content-type": "multipart/form-data"}});
    
}

function exportExcel(data){
    const url =  "/basedata/raceDoc/exportExcel";
    return axios.post(url, data, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Race Doc"+ (new Date()).valueOf() +".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

export default {
    add,
    del,
    update,
    query,
    get,
    select,
    importExcel,
    exportExcel
}